import ValueEditorPropertyValue from './ValueEditorPropertyValue';

export default ValueEditorPropertyValue;
export { ValueEditorPropertyValue };
